var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"px-2"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('i',{class:_vm.sectionIcon}),_c('span',{staticClass:"ml-1 text-uppercase",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.section))])]),_c('div',{class:[
            _vm.hasBorder ? 'bordered p-1 p-md-2' : '',
            'mt-1 d-flex flex-column justify-content-center',
        ]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }